import { SubscriptionCheckoutApiService } from './service';
import ApiClientFactory from '../../../api/client-factory';

const service = new SubscriptionCheckoutApiService(ApiClientFactory());

export function SubscriptionCheckoutApiServiceFactory(): typeof service {
  return service;
}
